export async function setExistingFiles(
  fileId: string | number
): Promise<{ id: string | number | null; url: string }> {
  try {
    const file = await downloadFileFromApi(fileId)

    if (!file) {
      return { id: null, url: '' }
    }

    const objectURL = URL.createObjectURL(file)
    return { id: fileId, url: objectURL }
  } catch (e) {
    return { id: null, url: '' }
  }
}
